export const topics = [
  { id: "headlines", name: "Notícias", icon: "radiowaves_right" },
  { id: "world", name: "Mundo", icon: "globe" },
  { id: "brazil", name: "Brasil", icon: "flag" },
  { id: "politic", name: "Política", icon: "person_3_fill" },
  { id: "technology", name: "Tecnologia", icon: "device_desktop" },
  { id: "gaming", name: "Jogos", icon: "gamecontroller" },
  { id: "economy", name: "Economia", icon: "money_dollar_circle" },
  { id: "health", name: "Saúde e Bem-Estar", icon: "staroflife_fill" },
  { id: "science", name: "Ciência", icon: "rays" },
  { id: "entertainment", name: "Entretenimento", icon: "today" },
  { id: "cinema", name: "Cinema", icon: "film" },
  { id: "travel", name: "Viagens", icon: "briefcase" },
];
